import { render, staticRenderFns } from "./CreditClassStudentPoint.vue?vue&type=template&id=2819911a&"
import script from "./CreditClassStudentPoint.vue?vue&type=script&lang=js&"
export * from "./CreditClassStudentPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports